import {Pipe, PipeTransform} from "@angular/core";
import {InvoiceAppearance} from "src/enums/invoice-appearance.enum";
@Pipe({
    name: "invoiceAppearance",
    standalone: false
})
export class InvoiceAppearancePipe implements PipeTransform {
    constructor() { }

    transform(value?: number): string | void {
        if (typeof value === 'undefined' || value < 0) return;

        return InvoiceAppearance[value];
    }
}